module.exports = __webpack_public_path__ + "img/aetc.a47b77fa.png";